module.exports = __webpack_public_path__ + "static/img/11.aa50d13.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic/11.jpg
// module id = MW2f
// module chunks = 1